import { render } from "./login.vue?vue&type=template&id=2bf20478&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=2bf20478&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bf20478"

export default script